import { render, staticRenderFns } from "./RegisteredProductsRequestRepair.vue?vue&type=template&id=4e91faba"
import script from "./RegisteredProductsRequestRepair.vue?vue&type=script&lang=js"
export * from "./RegisteredProductsRequestRepair.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports